<div class="container">
  <div class="content">
    <h1>403</h1>
    <h2>Access Forbidden</h2>
    @if (isDarkMode$ | async) {
      <img ngSrc="assets/logo-white.svg" alt="Speaksee logo" width="150" height="30" priority />
    } @else {
      <img ngSrc="assets/logo.svg" alt="Speaksee logo" width="150" height="30" priority />
    }
    <h4 style="line-height: 100px">
      Sorry, you do not have permission to access this page.
    </h4>
  </div>
</div>
